/**
 * Reason-code taxonomy for admin-created patient profiles — mirrors
 * system-backend's `CREATE_PROFILE_REASON_CODES`
 * (app/services/patient_profile_builder.py) and the
 * patient_profile_actions CHECK constraint. Keep all three in sync.
 */

export const CREATE_PROFILE_REASON_CODES: string[] = [
  'careportals_migration',
  'new_hire',
  'ghost_profile_fix',
  'white_glove_vip',
  'test_account',
  'other',
];

const LABELS: Record<string, string> = {
  careportals_migration: 'CarePortals migration',
  new_hire: 'New hire',
  ghost_profile_fix: 'Ghost profile fix',
  white_glove_vip: 'White-glove VIP',
  test_account: 'Test account',
  other: 'Other…',
};

export function profileReasonCodeLabel(code: string): string {
  return LABELS[code] ?? code;
}
